import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown } = FiIcons;

// --- EDIT THIS ARRAY TO CHANGE FAQ TEXT ---
const faqs = [
  {
    question: "How does it help restaurants get more reviews?",
    answer: "We place a simple code on your website that displays the eye-catching widget. The customer can click the widget or scan a QR code and are instantly shown a simple page asking them to leave a review — on Google, Yelp, Facebook, TripAdvisor, or wherever you want them most."
  },
  {
    question: "Can I send customers to my VIP club or loyalty program?",
    answer: "Yes! After requesting a review, customers can automatically be redirected to any destination you choose, including your VIP club, loyalty program, online ordering page, catering page, gift card page, reservations page, or any special promotion."
  },
  {
    question: "Can it be customized for my restaurant?",
    answer: "Absolutely. The widget can be fully customized with your own photos, branding, and messaging to ensure it matches your restaurant's unique style and voice. The size of the widget can be increased or decreased to your preference, both for desktop and mobile. It can also be positioned anywhere on your website. The page order can be changed- for example, the offer page can be first, and review page second."
  },
  {
    question: "Can I choose which pages display the widget?",
    answer: "Yes. The widget can be shown only on the pages you select and turned off on any page, including online ordering, cart, checkout, menu, or other pages where you do not want it displayed."
  },
  {
    question: "Is the software easy to use for restaurants who may not be tech-savvy?",
    answer: "Completely. Once it's set up, you don't have to touch it — your customers do the work. The widget runs on its own whether it's placed on your website, printed as a QR code on table tents, menus, or coasters, or shared as a link via email or text."
  },
  {
    question: "Is there a long-term contract?",
    answer: "No. You get a 30-day free test with no credit card required. After that, it's just $49/month, and you can cancel anytime with zero commitments."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:border-slate-300 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
              >
                <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                <SafeIcon 
                  icon={FiChevronDown} 
                  className={`w-5 h-5 text-slate-400 transition-transform duration-200 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} 
                />
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-6 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-4">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;